import * as yup from "yup";

export default function createChecklistItemSchema() {
  return yup.object().shape({
    task: yup.string().required(),
    assignedTo: yup.string(),
  });
}
